import { StateCreator } from 'zustand'
import { DataAPI } from '../../data/Data'
import { BoundStore } from '../bound.store'
import { RocketChannel, RocketchatSlice } from './rocketchat.interface'

export const createRocketchatSlice: StateCreator<
    BoundStore,
    [['zustand/devtools', never]],
    [],
    RocketchatSlice
> = (set, get) => ({
    pushedTokens: [],
    rocketchannels: {} as Record<number, RocketChannel[]>,
    pullRocketChatChannels: async () => {
        const { selectedItinID } = get()
        if (selectedItinID === -1) return
        const channels = await DataAPI.rocketchat.getChannels(selectedItinID)

        if (channels.status === 'success')
            set((state) => ({
                ...state,
                rocketchannels: {
                    ...state.rocketchannels,
                    [selectedItinID]: channels.data ?? [],
                },
            }))
    },
    getDirectChannel: async (user_id: number, user_id2: number) => {
        const { rocketchannels } = get()
        const directChannelList = Object.values(rocketchannels)
            .flat()
            .find(
                (channel) =>
                    channel.type === 'direct' &&
                    channel.members.includes(user_id) &&
                    channel.members.includes(user_id2)
            )
        return directChannelList
    },
})

//MARK : SELECTORS
export const selectRocketChatChannels = (state: BoundStore) => {
    const { selectedItinID, rocketchannels } = state
    return rocketchannels[selectedItinID] ?? []
}
